import React, {ReactNode} from 'react'

interface HighlightProps {
  children?: ReactNode
}

export const Highlight = ({children}: HighlightProps) => {
  return (
    <div className="grid-container">
      <span className="text-container">{children}</span>
      <svg
        className="highlight"
        preserveAspectRatio="none"
        width="146"
        height="29"
        viewBox="0 0 146 29"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M141.218 28.4151C127.419 28.4151 127.419 27.9281 113.602 27.9281C99.7855 27.9281 99.7855 28.5775 85.9869 28.5775C72.17 28.5775 72.17 28.3948 58.3715 28.3948C44.5546 28.3948 44.5546 27.2381 30.756 27.2381C16.9391 27.2381 16.9391 28.5775 3.14057 28.5775C1.52799 28.5775 -0.121243 26.2032 0.0070303 24.4174C0.831645 14.413 0.758346 14.3927 1.56464 4.40862C1.69291 2.82578 3.34214 1.20234 4.77147 1.20234C18.57 1.20234 18.57 2.11552 32.3869 2.11552C46.2038 2.11552 46.2038 1.38498 60.0024 1.38498C73.8009 1.38498 73.8192 1.28351 87.6178 1.28351C101.416 1.28351 101.435 0.897949 115.233 0.897949C129.032 0.897949 129.05 1.58791 142.849 1.58791C144.48 1.58791 145.634 3.19105 145.487 4.99712C144.663 15.0015 144.241 14.9609 143.417 24.9653C143.288 26.5482 142.629 28.4354 141.199 28.4354L141.218 28.4151Z" />
      </svg>
    </div>
  )
}
